// extracted by mini-css-extract-plugin
export var gentable = "product-table-module--gentable--eBo8Y";
export var overflow = "product-table-module--overflow--MaGC6";
export var tableheading = "product-table-module--tableheading--K79uZ";